export function renderMarkdown(md) {
  if (!md) return '<p class="md-empty">Nothing to preview.</p>';

  let h = md
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    // fenced code blocks
    .replace(/```[\w]*\n?([\s\S]*?)```/g, '<pre><code>$1</code></pre>')
    // inline code
    .replace(/`([^`\n]+)`/g, '<code>$1</code>')
    // bold + italic
    .replace(/\*\*\*([^*\n]+)\*\*\*/g, '<strong><em>$1</em></strong>')
    // bold
    .replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>')
    // italic
    .replace(/\*([^*\n]+)\*/g, '<em>$1</em>')
    // links
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
    // headings
    .replace(/^### (.+)$/gm, '<h3>$1</h3>')
    .replace(/^## (.+)$/gm,  '<h2>$1</h2>')
    .replace(/^# (.+)$/gm,   '<h1>$1</h1>')
    // list items
    .replace(/^[-*] (.+)$/gm, '<li>$1</li>')
    // wrap consecutive <li> in <ul>, stripping inter-item newlines
    .replace(/((?:<li>.*<\/li>\n?)+)/g, (m) => '<ul>' + m.replace(/\n/g, '') + '</ul>')
    // paragraphs
    .replace(/\n\n+/g, '</p><p>')
    .replace(/\n/g, '<br>');

  return `<p>${h}</p>`;
}
